
import { RoutinesList } from "../RoutinesList";

interface RoutineListContentProps {
  routines: any[];
  onRoutinesChange: () => void;
  onRemoveRoutine: (routineId: string) => Promise<void>;
  showRemoveButton: boolean;
  planId: string;
  isPersonalPlan: boolean;
  canEdit: boolean;
  hideDaySelector?: boolean;
}

export const RoutineListContent = ({
  routines,
  onRoutinesChange,
  onRemoveRoutine,
  showRemoveButton,
  planId,
  isPersonalPlan,
  canEdit,
  hideDaySelector,
}: RoutineListContentProps) => {
  if (!routines || routines.length === 0) {
    return (
      <div className="text-center py-8 text-white/60">
        No hay rutinas en este plan
      </div>
    );
  }

  return (
    <RoutinesList 
      planId={planId}
      routines={routines}
      onRoutinesChange={onRoutinesChange}
      onRemoveRoutine={onRemoveRoutine}
      showRemoveButton={showRemoveButton}
      isPersonalPlan={isPersonalPlan}
      canEdit={canEdit}
      hideDaySelector={hideDaySelector}
    />
  );
};
